var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('head-preloader'),_c('flash-box'),_c('the-navigation'),_c('version-alert',{attrs:{"id":"sticky-notice"}}),_vm._t("default",function(){return [_c('router-view')]}),_c('base-modal')],2)}
var staticRenderFns = []

export { render, staticRenderFns }